module.exports = "pegasus_template/assets/lp/charity/bg0.png";